import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config from "./aws-exports";
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

Amplify.configure(config);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// const router = createBrowserRouter([
//   {
//     path:"/",
//     element: <App/>,
//   },

// ]);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <RouterProvider router={router} />
// );
